import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const chatApi = createApi({
  reducerPath: 'nfChatApp',

  baseQuery: fetchBaseQuery({ baseUrl: '/nf_chat' }),

  endpoints: (builder) => ({
    getContacts: builder.query({
      query: () => 'contacts',
      transformResponse: (response) => {
        return {
          contacts: response.data_for_normalization,
          allContactsLoaded: response.all_contacts_loaded,
        };
      },
    }),

    getMessages: builder.query({
      query: ({ selectedUserId, maxId, perPage }) => {
        return {
          url: 'text_chat/messages',
          params: {
            selected_user_id: selectedUserId,
            max_id: maxId,
            per_page: perPage,
          },
        };
      },
    }),

    sendMessage: builder.mutation({
      query: ({ content, recipientId, refId }) => ({
        url: '/text_chat/messages',
        method: 'POST',
        body: {
          recipient_id: recipientId,
          ref_id: refId,
          content,
        },
      }),
    }),
  }),
});

export default chatApi;

export const {
  useGetContactsQuery,
  useLazyGetMessagesQuery,
  useSendMessageMutation,
} = chatApi;
